import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import CustomSwitch from "../../../../components/switch/CustomSwitch";
import {FormattedMessage} from "react-intl";
import BeatLoaderRegular from "../../../../components/loaders/BeatLoaderRegular";
import {MissionModelListContext} from "../MissionModelListContext";

ActiveButton.propTypes = {
    missionModel: PropTypes.object.isRequired
};

function ActiveButton({missionModel}) {
    const {
        handlePatchModel,
        loading,
        setLoading
    } = useContext(MissionModelListContext)
    
    const [isActive, setIsActive] = useState();

    const handleClick = () => {
        setLoading(true)
        handlePatchModel(missionModel, {enabled: !isActive})
    }

    useEffect(() => {
        if (missionModel) {
            setIsActive(missionModel.enabled)
        }
    }, [missionModel]);

    if (loading) {
        return (
            <BeatLoaderRegular loading={true} size={10} />
        )
    }

    return (
        <CustomSwitch
            checked={isActive}
            label={isActive ? <FormattedMessage id={"wms.pickingMissionList.isActive"}/> : <FormattedMessage id={"wms.pickingMissionList.isNotActive"}/>}
            onClick={() => handleClick()}
        />
    );
}

export default ActiveButton;